import { createAction, props } from '@ngrx/store';
import { JobListArgs, PagedResultsOfJobSummary } from 'src/shared/api';

export const quoteListDestroyed = createAction('[Quotes] Quote List Destroyed');

export const pagedQuotesLoaded = createAction(
	'[Quotes] Quotes Loaded',
	props<{ pagedQuotes: PagedResultsOfJobSummary; listArgs: JobListArgs }>()
);

export const errorLoadingQuotes = createAction(
	'[Quotes] Error Loading Quotes',
	props<{ error: any }>()
);

export const filtersUpdated = createAction(
	'[Quotes] Filters Updated',
	props<{ filters: JobListArgs }>()
);

export const userConfirmedCancelQuote = createAction(
	'[Quotes] User Clicked Cancel Quote',
	props<{ quoteId: number }>()
);

export const navigatedWithoutAnyParams = createAction(
	'[Quotes] Navigated Without Any Params'
);

export const navigatedWithoutPagingParams = createAction(
	'[Quotes] Navigated Without Paging Params',
	props<{ listArgs: JobListArgs }>()
);

export const localTeamPrefUpdated = createAction(
	'[Quotes] Local Team Pref Updated',
	props<{ teamId: number | null }>()
);

export const localPagePrefUpdated = createAction(
	'[Quotes] Local Page Pref Updated',
	props<{ pageSize: number }>()
);
